<div
  class="answer-container"
  [class.answer-found]="isCompleteAnswer() && model()?.text"
  [class.look-up]="isResourceLookup()"
  [class.active-menu]="contextMenuActive() || isFeedbackOpen() || resourcePopupActiveIndex()"
  (mouseenter)="isHovered.set(true)"
  (mouseleave)="isHovered.set(false)"
>
  <div class="icon-ai">
    <u-icon
      class="close-icon"
      [model]="{ type: 'font', value: 'icon-answer' }"
      [styles]="{ fontSize: '22px', color: 'var(--color-primary)' }"
    ></u-icon>
  </div>
  <div
    class="answer-text"
    customResourcePanel
    [resources]="model()?.resources"
    [typing]="answerTypingFinished()"
    [isResourceLookup]="isResourceLookup()"
  >
    <u-typing-typography
      [viewMode]="typingViewMode()"
      [text]="this.model()?.formattedAnswer || this.model()?.text || (this.isResourceLookup() ? NO_ANSWER_TEXT_LOOK_UP : NO_ANSWER_TEXT)"
      (typingFinished)="answerTypingFinished.set(true)"
    >
    </u-typing-typography>
    @if (debugEnv) {
      <div style="word-break: break-all">
        <strong>SearchId: </strong><a (click)="openSearchLog(model()?.searchId)">{{ model()?.searchId }}</a>
      </div>
    }
  </div>
  @if (isCompleteAnswer()) {
    <div class="answer-resources" [ngStyle]="enableDisclaimer() ? { marginBottom: '8px' } : {}">
      @if (!isResourceLookup()) {
        <short-result-resources
          [resources]="model().resources"
          [displayHeader]="true"
          [sessionId]="sessionId()"
          [searchId]="model()?.searchId"
          [showResourcesNumbers]="showResourcesNumbers()"
          [resourceActiveIndex]="resourcePopupActiveIndex()"
          (menuActive)="contextMenuActive.set($event)"
        ></short-result-resources>
      }
      @if (model()?.text && hideFollowUp()) {
        <ng-container [ngTemplateOutlet]="answerActions"></ng-container>
      }
    </div>
    @if (!hideFollowUp()) {
      <div class="answer-footer" [ngStyle]="enableDisclaimer() ? { marginBottom: '12px' } : {}">
        <div class="ask-follow-up">
          <u-button
            [versionNumber]="2"
            sizeElement="small"
            styleType="outlined"
            fontIcon="chat-dots"
            [label]="model()?.text || model()?.formattedAnswer ? 'Ask a Follow-up' : 'Chat'"
            (onClick)="onFollowUpChat.emit()"
          ></u-button>
        </div>
        @if (model()?.text || model()?.formattedAnswer) {
          <ng-container [ngTemplateOutlet]="answerActions"></ng-container>
        }
      </div>
    }
    @if (enableDisclaimer() && model()?.text) {
      <disclaimer-alert></disclaimer-alert>
    }
  }
</div>

<!-- TEMPLATES -->
<ng-template #answerActions>
  <answer-actions
    [model]="{
      answer: model()?.text,
      questionQuery: model()?.query,
      formattedAnswer: model()?.formattedAnswer,
      resources: model()?.resources,
      answerIntent: model()?.intent,
      collectionId: model()?.collectionId,
    }"
    [searchId]="model()?.searchId"
    [active]="isHovered() || resourcePopupActiveIndex()"
    [isFeedbackOpen]="isFeedbackOpen()"
    (feedbackShow)="feedbackShow.emit($event)"
    (actionClosed)="contextMenuActive.set(false)"
  ></answer-actions>
</ng-template>
